import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import { Link } from "react-router-dom";
import { ReviewCommentRowApiDto } from "../common/dto/ReviewCommentRowApiDto";

type Props = { username: string }

export default class ReviewCommentTable extends Component<ServiceCollectionParam & Props, {}> {

    state: { rows: ReviewCommentRowApiDto[] } = {
        rows: []
    }

    async componentDidMount() {
        this.state.rows = await this.props.services.dao
            .findReviewCommentRows(this.props.username);

        this.setState(this.state);
    }

    render() {
        return (
            <>
            <table className="table table-sm caption-top user-dashboard">
                <caption>Kommentaarid minu koodile</caption>
                <thead>
                <tr>
                    <th scope="col">Tag</th>
                    <th scope="col">Räsi</th>
                    <th scope="col">Kommentaare</th>
                </tr>
                </thead>
                <tbody>
                { this.state.rows.map(row =>
                    <tr key={ row.tag }>
                        <td><Link to={`/comment-list/${this.props.username}/${row.tag}`}>{row.tag}</Link></td>
                        <td>{ row.hash }</td>
                        <td>{ row.count }</td>
                    </tr>
                )}
                </tbody>
            </table>
            </>);
    }
}
